import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import "./ProductDetailHeader.css";

const ServiceDescriptionHeader = () => {
  const { state } = useLocation();
  const storedProductId = localStorage.getItem("selectedProductId");
  const [product, setProduct] = useState(null);

  // useEffect(() => {
  //   const fetchProducts = async () => {
  //     if (!storedProductId) return;

  //     try {
  //       // const response = await axios.get(`${baseURl}/api/v1/product`);
  //       // const products = ressponse.data.data || [];

  //       // const selectedProduct = products.find((p) => p._id === storedProductId);
  //       // setProduct(selectedProduct || null);
  //     } catch (error) {
  //       console.error("Error fetching product details:", error);
  //     }
  //   };

  //   fetchProducts();
  // }, [storedProductId]);

  return (
    <div
      className="service-header44"
      // style={{ backgroundImage: `url(${header_img})` }}
    >
      <div className="overlay23">
        {/* <h1>{product ? product.title : "Product Details"}</h1> */}
        {/* <span className="arrow">&#x25BC;</span> */}
      </div>
    </div>
  );
};

export default ServiceDescriptionHeader;